/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PermitERC20UniswapV3Paymaster,
  PermitERC20UniswapV3PaymasterInterface,
} from "../PermitERC20UniswapV3Paymaster";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract ISwapRouter",
            name: "uniswap",
            type: "address",
          },
          {
            internalType: "contract IERC20",
            name: "weth",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "minSwapAmount",
            type: "uint256",
          },
          {
            internalType: "contract IERC20[]",
            name: "tokens",
            type: "address[]",
          },
          {
            internalType: "contract IChainlinkOracle[]",
            name: "priceFeeds",
            type: "address[]",
          },
          {
            internalType: "uint24[]",
            name: "uniswapPoolFees",
            type: "uint24[]",
          },
          {
            internalType: "string[]",
            name: "permitMethodSignatures",
            type: "string[]",
          },
          {
            internalType: "uint8[]",
            name: "slippages",
            type: "uint8[]",
          },
          {
            internalType: "bool[]",
            name: "reverseQuotes",
            type: "bool[]",
          },
        ],
        internalType: "struct PermitERC20UniswapV3Paymaster.UniswapConfig",
        name: "uniswapConfig",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "gasUsedByPost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minHubBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "targetHubBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minWithdrawalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paymasterFee",
            type: "uint256",
          },
        ],
        internalType: "struct PermitERC20UniswapV3Paymaster.GasAndEthConfig",
        name: "gasAndEthConfig",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "contract IRelayHub",
        name: "_relayHub",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "eth",
        type: "uint256",
      },
    ],
    name: "Received",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "gasJustPost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenActualCharge",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethActualCharge",
        type: "uint256",
      },
    ],
    name: "TokensCharged",
    type: "event",
  },
  {
    inputs: [],
    name: "CALLDATA_SIZE_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "FORWARDER_HUB_OVERHEAD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAYMASTER_ACCEPTANCE_BUDGET",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POST_RELAYED_CALL_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRE_RELAYED_CALL_GAS_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gasUsedByPost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRelayHub",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minHubBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minSwapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minWithdrawalAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paymasterFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "context",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "gasUseWithoutPost",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxPriorityFeePerGas",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "transactionCalldataGasUsed",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "relayWorker",
            type: "address",
          },
          {
            internalType: "address",
            name: "paymaster",
            type: "address",
          },
          {
            internalType: "address",
            name: "forwarder",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "paymasterData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "clientId",
            type: "uint256",
          },
        ],
        internalType: "struct GsnTypes.RelayData",
        name: "relayData",
        type: "tuple",
      },
    ],
    name: "postRelayedCall",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "from",
                type: "address",
              },
              {
                internalType: "address",
                name: "to",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "value",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "gas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
              },
              {
                internalType: "bytes",
                name: "data",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "validUntilTime",
                type: "uint256",
              },
            ],
            internalType: "struct IForwarder.ForwardRequest",
            name: "request",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maxFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "maxPriorityFeePerGas",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "transactionCalldataGasUsed",
                type: "uint256",
              },
              {
                internalType: "address",
                name: "relayWorker",
                type: "address",
              },
              {
                internalType: "address",
                name: "paymaster",
                type: "address",
              },
              {
                internalType: "address",
                name: "forwarder",
                type: "address",
              },
              {
                internalType: "bytes",
                name: "paymasterData",
                type: "bytes",
              },
              {
                internalType: "uint256",
                name: "clientId",
                type: "uint256",
              },
            ],
            internalType: "struct GsnTypes.RelayData",
            name: "relayData",
            type: "tuple",
          },
        ],
        internalType: "struct GsnTypes.RelayRequest",
        name: "relayRequest",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "approvalData",
        type: "bytes",
      },
      {
        internalType: "uint256",
        name: "maxPossibleGas",
        type: "uint256",
      },
    ],
    name: "preRelayedCall",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRelayHub",
        name: "hub",
        type: "address",
      },
    ],
    name: "setRelayHub",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "targetHubBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokensBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    name: "tokensSwapData",
    outputs: [
      {
        internalType: "contract IChainlinkOracle",
        name: "priceFeed",
        type: "address",
      },
      {
        internalType: "bool",
        name: "reverseQuote",
        type: "bool",
      },
      {
        internalType: "uint24",
        name: "uniswapPoolFee",
        type: "uint24",
      },
      {
        internalType: "uint8",
        name: "slippage",
        type: "uint8",
      },
      {
        internalType: "bytes4",
        name: "permitMethodSelector",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "priceDivisor",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "validFromBlockNumber",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswap",
    outputs: [
      {
        internalType: "contract ISwapRouter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "target",
        type: "address",
      },
    ],
    name: "withdrawRelayHubDepositTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract ISwapRouter",
            name: "uniswap",
            type: "address",
          },
          {
            internalType: "contract IERC20",
            name: "weth",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "minSwapAmount",
            type: "uint256",
          },
          {
            internalType: "contract IERC20[]",
            name: "tokens",
            type: "address[]",
          },
          {
            internalType: "contract IChainlinkOracle[]",
            name: "priceFeeds",
            type: "address[]",
          },
          {
            internalType: "uint24[]",
            name: "uniswapPoolFees",
            type: "uint24[]",
          },
          {
            internalType: "string[]",
            name: "permitMethodSignatures",
            type: "string[]",
          },
          {
            internalType: "uint8[]",
            name: "slippages",
            type: "uint8[]",
          },
          {
            internalType: "bool[]",
            name: "reverseQuotes",
            type: "bool[]",
          },
        ],
        internalType: "struct PermitERC20UniswapV3Paymaster.UniswapConfig",
        name: "config",
        type: "tuple",
      },
    ],
    name: "setUniswapConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "gasUsedByPost",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minHubBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "targetHubBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "minWithdrawalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "paymasterFee",
            type: "uint256",
          },
        ],
        internalType: "struct PermitERC20UniswapV3Paymaster.GasAndEthConfig",
        name: "config",
        type: "tuple",
      },
    ],
    name: "setGasAndEthConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokens",
    outputs: [
      {
        internalType: "contract IERC20[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "getTokenSwapData",
    outputs: [
      {
        components: [
          {
            internalType: "contract IChainlinkOracle",
            name: "priceFeed",
            type: "address",
          },
          {
            internalType: "bool",
            name: "reverseQuote",
            type: "bool",
          },
          {
            internalType: "uint24",
            name: "uniswapPoolFee",
            type: "uint24",
          },
          {
            internalType: "uint8",
            name: "slippage",
            type: "uint8",
          },
          {
            internalType: "bytes4",
            name: "permitMethodSelector",
            type: "bytes4",
          },
          {
            internalType: "uint256",
            name: "priceDivisor",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "validFromBlockNumber",
            type: "uint256",
          },
        ],
        internalType: "struct PermitERC20UniswapV3Paymaster.TokenSwapData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "refillHubDeposit",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
    ],
    name: "withdrawTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "divisor",
        type: "uint256",
      },
    ],
    name: "toActualQuote",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "reverse",
        type: "bool",
      },
    ],
    name: "tokenToWei",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quote",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "reverse",
        type: "bool",
      },
    ],
    name: "weiToToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
    ],
    name: "isTokenSupported",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "charge",
        type: "uint256",
      },
    ],
    name: "addPaymasterFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "slippage",
        type: "uint8",
      },
    ],
    name: "addSlippage",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getGasAndDataLimits",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "acceptanceBudget",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "preRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "postRelayedCallGasLimit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "calldataSizeLimit",
            type: "uint256",
          },
        ],
        internalType: "struct IPaymaster.GasAndDataLimits",
        name: "limits",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "versionPaymaster",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTrustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_forwarder",
        type: "address",
      },
    ],
    name: "setTrustedForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type PermitERC20UniswapV3PaymasterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PermitERC20UniswapV3PaymasterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PermitERC20UniswapV3Paymaster__factory extends ContractFactory {
  constructor(...args: PermitERC20UniswapV3PaymasterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    uniswapConfig: PermitERC20UniswapV3Paymaster.UniswapConfigStruct,
    gasAndEthConfig: PermitERC20UniswapV3Paymaster.GasAndEthConfigStruct,
    _trustedForwarder: string,
    _relayHub: string,
    overrides?: Overrides & { from?: string }
  ): Promise<PermitERC20UniswapV3Paymaster> {
    return super.deploy(
      uniswapConfig,
      gasAndEthConfig,
      _trustedForwarder,
      _relayHub,
      overrides || {}
    ) as Promise<PermitERC20UniswapV3Paymaster>;
  }
  override getDeployTransaction(
    uniswapConfig: PermitERC20UniswapV3Paymaster.UniswapConfigStruct,
    gasAndEthConfig: PermitERC20UniswapV3Paymaster.GasAndEthConfigStruct,
    _trustedForwarder: string,
    _relayHub: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      uniswapConfig,
      gasAndEthConfig,
      _trustedForwarder,
      _relayHub,
      overrides || {}
    );
  }
  override attach(address: string): PermitERC20UniswapV3Paymaster {
    return super.attach(address) as PermitERC20UniswapV3Paymaster;
  }
  override connect(signer: Signer): PermitERC20UniswapV3Paymaster__factory {
    return super.connect(signer) as PermitERC20UniswapV3Paymaster__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PermitERC20UniswapV3PaymasterInterface {
    return new utils.Interface(_abi) as PermitERC20UniswapV3PaymasterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PermitERC20UniswapV3Paymaster {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PermitERC20UniswapV3Paymaster;
  }
}
